<script>
// CommitChart.js
import {HorizontalBar} from 'vue-chartjs'
import Utils from "../../scripts/utils";

export default {
    extends: HorizontalBar,
    data() {
        return {
            lastData: this.data,
            colors: ['#00b6ed', '#4069aa', '#752b77', '#d70364', '#F56612', '#F4A716', '#FCF80D', '#BDE845', '#7ED77D', '#3FC7B5', 'lightGrey'],
            hovering: false,
        }
    },
    props: {
        labels: {
            required: true,
            type: Array
        },
        data: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        unit: {
            type: String,
            default: ''
        },
        digits: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        },
        width: {
            type: [Number, String],
            default: 500
        },
        height: {
            type: [Number, String],
            default: 200
        },
        multipleDatasets: {
            type: Boolean,
            default: false,
        },
        currentChartFilter: {}
    },
    computed: {
        chartData: function () {
            return this.data;
        },
        length() {
            return Utils.calcColWidth * 0.7;
        },
        editedData() {
            if (this.data.length <= 8) {
                return {
                    data: this.data,
                    labels: this.labels
                }
            }
            let labels = []
            for (let i = 0; i < this.data.length; i++) {
                labels[this.data[i]] = this.labels[i];
            }
            let copy = this.data;
            let tmp = copy.sort((a, b) => b - a);
            let tmp2 = {data: [], labels: []};
            let others = 0;
            for (let i = 0; i < tmp.length; i++) {
                if (i < 7) {
                    tmp2.data.push(tmp[i]);
                    tmp2.labels.push(labels[tmp[i]]);
                } else {
                    others += tmp[i]
                }
            }
            if (others > 0) {
                tmp2.data.push(others)
                tmp2.labels.push('Sonstige')
            }
            return tmp2;
        },
        multiDatasetWithColor() {
            let ret = this.data.length !== 0 ? JSON.parse(JSON.stringify(this.data)) : [];
            for (let i = 0; i < ret.length; i++) {
                if (typeof ret[i].backgroundColor === "undefined") ret[i].backgroundColor = this.colors[i];
            }
            return ret;
        }
    },
    mounted() {
        this.init(true);
        window.addEventListener('resize', function () {
            this.reRender(false)
        }.bind(this));
    },
    methods: {
        init(animated) {
            if (this.$refs.canvas) {
                this.$refs.canvas.style['max-width'] = this.w + 'px';
                this.$refs.canvas.style['max-height'] = this.h + 'px';
            }
            const options = {
                //  responsive: false,
                // maintainAspectRatio: false,
                //responsive: true,
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            ticks: {
                                fontStyle: 'bold',
                                callback: function (label) {
                                    label = parseFloat(label);
                                    let digits = this.unit === "€" && label < 0 ? 2 : 0
                                    label = label.toLocaleString('de-DE', {
                                        minimumFractionDigits: digits,
                                        maximumFractionDigits: digits
                                    });
                                    return label + ' ' + this.unit;
                                }.bind(this),
                            }
                        },
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            ticks: {
                                fontStyle: 'bold'
                            }
                        },
                    ],
                },
                /*plugins: {
                    datalabels: {
                        display: false,
                        font: {
                            size: 14,
                        },
                        formatter: function (value, context) {
                            console.log(context)
                            return context.dataset.label; // Display the raw value as the label
                        },
                        color: 'white',
                        clamp: true,
                    },
                },*/
                animation: {
                    duration: animated ? 1000 : 0
                },
                tooltips: {
                    /*callbacks: {
                        label: function (tooltipItem, data) {
                            let number = data['datasets'][0]['data'][tooltipItem['index']];
                            let label = data['labels'][tooltipItem['index']];
                            number = parseFloat(number);
                            number = number.toLocaleString('de-DE', {
                                minimumFractionDigits: this.digits,
                                maximumFractionDigits: this.digits
                            });
                            return label + ':  ' + number + ' ' + this.unit;
                        }.bind(this)
                    }*/
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if (data.rawData) {
                                let number = data.rawData[tooltipItem.datasetIndex][this.currentChartFilter.name];
                                number = number ? number.toLocaleString('de-DE', {
                                    minimumFractionDigits: this.unit === "€" ? 2 : 0,
                                    maximumFractionDigits: 2
                                }) : null;

                                return data.rawData[tooltipItem.datasetIndex].cust_Name +
                                    ': \n' + number + (this.unit ? ' ' + this.unit : '');
                            } else {
                                return 'no data';
                            }
                        }.bind(this),
                        title: function () {
                            return '';
                        }
                    },

                },
                legend: {
                    display: true,
                    position: 'bottom',
                },
                title: {
                    display: this.title !== '',
                    text: this.title,
                    fontSize: 13,
                    family: 'Arial'
                },
            };
            // Overwriting base render method with actual data.
            this.renderChart({
                labels: this.labels,
                datasets: this.multipleDatasets ? this.multiDatasetWithColor : [
                    {
                        backgroundColor: this.colors,
                        data: this.editedData.data
                    },
                ],
                rawData: this.$store.state.deals.dealData && typeof this.$store.state.deals.dealData.groupByAdvertiser !== "undefined" ? this.$store.state.deals.dealData.groupByAdvertiser : [],
            }, options)
        },
        arrayDiff
            (a, b) {
            return [...b.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                a.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map())
            )].reduce((acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), []);
        }
        ,
        reRender(animated) {
            this._data._chart.destroy();
            this.init(animated);
        }

    },
    watch: {
        data: function () {
            if (this.arrayDiff(this.data, this.lastData).length > 0) {
                this.lastData = this.data;
                this.reRender(true);
            }
        },
        editedData() {
            this.reRender(true);
        }
    }
}
</script>

<style scoped>

canvas {
    background-color: white;
    padding: 12px;
    margin: auto;
}

/*  @media (max-width: 767px) {
      canvas {
         // min-width: 90%;
      }
  }*/

</style>